import { API_ENDPOINTS } from '../../constants/apiEndpoints';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import fetcher from '../../helpers/fetcher';

export const getUserCount = async () => {
  try {
    const data = await fetcher.get(
      API_ENDPOINTS.DASHBOARD.GET_USER_COUNT,
      { timeInterval: 'lastmonth' },
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return data.data;
  } catch (error) {}
};

export const getProductCount = async () => {
  try {
    const data = await fetcher.get(
      API_ENDPOINTS.DASHBOARD.GET_PRODUCT_COUNT,
      { timeInterval: 'lastmonth' },
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return data.data;
  } catch (error) {
    throw error;
  }
};

export const getEstablishmentCount = async () => {
  try {
    const data = await fetcher.get(
      API_ENDPOINTS.ESTABLISHMENT.GET_ESTABLISHMENT_COUNT,
      { timeInterval: 'lastmonth' },
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return data.data;
  } catch (error) {
    throw error;
  }
};

export const getGeneratedReport = async (filterParams: any) => {
  try {
    const response = await fetcher.post(
      API_ENDPOINTS.NEWSLETTER.POST_GENERATED_REPORT,
      filterParams,
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getPriceVsVarianceGraphData = async (filterParams: any) => {
  try {
    const response = await fetcher.post(
      API_ENDPOINTS.NEWSLETTER.POST_GENERATED_GRAPH,
      filterParams,
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getEstablishmentList = async (queryParams?: any) => {
  try {
    const data = await fetcher.get(
      API_ENDPOINTS.ESTABLISHMENT.GET_ESTABLISHMENT_LIST,
      queryParams,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    const resData = data.data;
    if (resData?.data && typeof resData.data === 'object') {
      if (Array.isArray(resData.data.data)) {
        return resData.data;
      }
      if (Array.isArray(resData.data)) {
        return { data: resData.data, total: resData.total || resData.data.length };
      }
    }
    if (resData && Array.isArray(resData.data)) {
      return resData;
    }
    return { data: [], total: 0 };
  } catch (error) {
    throw error;
  }
};

export const createEstablishment = async (payload: any) => {
  try {
    const data = await fetcher.post(
      API_ENDPOINTS.ESTABLISHMENT.ESTABLISHMENT,
      payload,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateEstablishment = async (id: number, payload: any) => {
  try {
    const data = await fetcher.put(
      `${API_ENDPOINTS.ESTABLISHMENT.ESTABLISHMENT}/${id}`,
      payload,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteEstablishment = async (id: string) => {
  try {
    const data = await fetcher.del(
      `${API_ENDPOINTS.ESTABLISHMENT.ESTABLISHMENT}/${id}`,
      {},
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getEstablishmentTypeList = async () => {
  try {
    const data = await fetcher.get(
      API_ENDPOINTS.ESTABLISHMENT_TYPE.GET_ESTABLISHMENT_TYPE_LIST,
      {},
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    const resData = data.data;
    if (Array.isArray(resData)) return resData;
    if (Array.isArray(resData?.data)) return resData.data;
    if (resData?.data?.data && Array.isArray(resData.data.data)) return resData.data.data;
    return [];
  } catch (error) {
    throw error;
  }
};

export const createEstablishmentType = async (payload: any) => {
  try {
    const data = await fetcher.post(
      API_ENDPOINTS.ESTABLISHMENT_TYPE.ESTABLISHMENT_TYPE,
      payload,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateEstablishmentType = async (id: number, payload: any) => {
  try {
    const data = await fetcher.put(
      `${API_ENDPOINTS.ESTABLISHMENT_TYPE.ESTABLISHMENT_TYPE}/${id}`,
      payload,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteEstablishmentType = async (id: string) => {
  try {
    const data = await fetcher.del(
      `${API_ENDPOINTS.ESTABLISHMENT_TYPE.ESTABLISHMENT_TYPE}/${id}`,
      {},
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return data;
  } catch (error) {
    throw error;
  }
};
